import { axiosInstance, getToken } from "../utils/Api";

const adminConfig = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

export const getOnlineContact = async () => {
  const response = await axiosInstance.get("/online/contact");
  return response.data;
};

export const createOnlineContact = async (data) => {
  const response = await axiosInstance.post(
    "/admin/online/contact",
    data,
    adminConfig()
  );
  return response.data;
};

export const updateOnlineContact = async (data) => {
  const response = await axiosInstance.put(
    "/admin/online/contact",
    data,
    adminConfig()
  );
  return response.data;
};

export const deleteOnlineContact = async (keys) => {
  const response = await axiosInstance.delete("/admin/online/contact", {
    ...adminConfig(),
    data: { keys },
  });
  return response.data;
};

export const getOnlineFaqs = async () => {
  const response = await axiosInstance.get("/online/faqs");
  return response.data;
};

export const getOnlineFaq = async (id) => {
  const response = await axiosInstance.get(`/online/faqs/${id}`);
  return response.data;
};

export const createOnlineFaq = async (data) => {
  const response = await axiosInstance.post(
    "/admin/online/faqs",
    data,
    adminConfig()
  );
  return response.data;
};

export const updateOnlineFaq = async (id, data) => {
  const response = await axiosInstance.put(
    `/admin/online/faqs/${id}`,
    data,
    adminConfig()
  );
  return response.data;
};

export const deleteOnlineFaq = async (id) => {
  const response = await axiosInstance.delete(`/admin/online/faqs/${id}`, adminConfig());
  return response.data;
};
